export default "__VITE_ASSET__0fcf4e1e__"